import React, { Component } from 'react';
import 'HELPDESK/Components/CoordinatorDetails/coordinatordetails.css';
import config from 'config';
import HelpdeskApiCall from 'HelpdeskApiCall';
import SuccessModal from 'HELPDESK/CommonResources/SuccessModal/SuccessModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLoader from 'HELPDESK/CommonResources/ButtonLoader/ButtonLoader';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactHtmlParser from 'react-html-parser';
import Pagination from 'react-js-pagination';
import DeleteTextModal from 'HELPDESK/CommonResources/DeleteTextModal/DeleteTextModal';
import ReactToPrint from 'react-to-print';
import ModulePresentation from 'HELPDESK/Components/CoordinatorDetails/ModulePresentation';
import { Base64, fromBase64, toBase64 } from 'js-base64';

class CoordinatorDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coordinatorFetching: false,
            coordinatorList: {},
            moduleListWithDemoPoint:{},
            filterName: '',
            pageIndex: 1,
            limit: 10,
            offset: 0,
            coordinatorCount: 0,

            // VARIABLES TO GET EMPLOYEE LIST
            employeeFetching: false,
            employeeList: {},
            searchTerm: '',

            // VARIABLES TO GET DEPARTMENT LIST
            departmentList: {},

            // VARIABLES TO GET MODULE LIST
            moduleFetching: false,
            moduleList: {},
            
            // VARIABLES TO ADD COORDINATOR
            addCoordinator: false,
            addingCoordinator: false,
            selectModule: false,
            tempSelectedModule: '',
            tempSelectedModuleName: '',
            selectedModule: '',
            selectedModuleName: '',
            moduleWarning: '',
            selectEmployee: false,
            tempSelectedEmployeeId: '',
            tempSelectedEmployeeName: '',
            selectedEmployeeId: '',
            selectedEmployeeName: '',
            selectedDepartmentIds: [],
            employeeWarning: '',

            // VARIABLES TO DELETE COORDINATOR 
            deleteCoordinator: false,
            moduleUniqueId: '',
            coordinatorId: '',

            //VARIABLES FOR ACCESS
            accessResponse :'',
            onboardingAccess:false,                        
            adminName:'',

            // VARIABLES FOR DEMO POINT ATTACHMENTS
            viewAttachment: false,
            attachmentArray: [],
            selectedAttachmentFile: '',
            currentAttachmentIndex: 0,

            // VARIABLES TO VIEW DETAILED PRESENTATION
            detailedPresentation: false,
            detailedModuleList: {},
            currentModuleId: '',
            currentModuleName: '',

            // VARIABLES TO SHIFT SUB MODULE
            currentSubModuleObject: {},
            subModuleIds: [],
            currentSubModuleId: '',
            currentSubModuleIndex: 0,
            subModuleNameObject: {},

            // VARIABLES TO SHIFT POINT
            currentPointIds: [],
            currentPointId: '',
            currentPointIndex: 0,
            currentPointNameObject: {},

            // VARIABLES TO SHIFT ATTACHMENT
            currentAttachmentArray: [],
            currentAttachmentPath: '',
            currentAttachmentIdx: 0,

            // VARIABLES TO COLLAPSE TABLE CONTENT
            collapseStatus: 'expanded'
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET COORDINATOR
        this.apiCallToGetCoordinatorList();

        // API CALL METHOD TO GET MODULE DETAILS
        this.apiCallToGetModuleList();

        // API CALL METHOD TO GET EMPLOYEE DETAILS
        this.apiCallToGetEmployeeList();

        // METHOD TO GET INSTITUTE STREAM LIST
        this.getInstituteStreamList();

        // METHOD CALLED TO GET INSTRUCTOR QUERIES COUNT
        this.apiCallToGetHelpDeskAccess();

        // API CALL METHOD TO GET MODULE DETAILS WITH DEMO POINT
        // this.apiCallToGetModuleListWithDemoPoint();
    }
    
    componentDidUpdate() {
        
        if(this.state.detailedPresentation) {
            document.onkeydown = (e) => {
                
                if(e.keyCode == 37) {
                    // METHOD TO GET PREVIOUS SUBMODULE POINT DETAILS
                    this.getPreviousPresentation(); 
                }else if(e.keyCode == 39) {
                    // METHOD TO GET NEXT SUBMODULE POINT DETAILS
                    this.getNextPresentation(); 
                }
            }
        }
    }

    // API CALL METHOD TO GET MODULE LIST
    apiCallToGetModuleList = async () => {
        this.setState({
            moduleFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMCurrentSubscriptionWiseModuleList',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    moduleFetching: false,
                    moduleList: apiResult
                });
            } else {
                this.setState({
                    moduleFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET HELP DESK ACCESS
    apiCallToGetHelpDeskAccess = async () => {
        let requestData = {
            "facultyId": config.faculty_id,
            "iid": config.institute_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskAccessDetails',
            requestData,
            '/api/helpDesk/employee/Onboarding.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetHelpDeskAccess()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let accessResponse = jsonResponse.APIResult.access_provided;
                let onboardingAccess = accessResponse.helpDeskOnboarding.isAccessGranted == "true" ? true : false;                
                
                let adminName = accessResponse.adminName;

                let manageOnboardingName = new Set();
                let helpDeskOnboardingAccessGranted = accessResponse.helpDeskOnboarding.accessGrantedTo;
                helpDeskOnboardingAccessGranted.map(facultyData => {
                    manageOnboardingName.add(facultyData.name);
                });

                this.setState({
                    accessResponse,
                    onboardingAccess,                        
                    adminName,
                });
            } else {
                this.setState({
                    instructorListFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting instructor list with query count. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET COORDINATOR LIST
    apiCallToGetCoordinatorList = async () => {
        this.setState({
            coordinatorFetching: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "page_index": this.state.pageIndex,
            "limit": this.state.limit,
            "module_name": this.state.filterName
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetPMModuleWiseCoordinatorList',
            requestData,
            '/api/projectManagement/client/coordinator.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetCoordinatorList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    coordinatorFetching: false,
                    coordinatorList: apiResult,
                    coordinatorCount: jsonResponse.APIResult.totalCount
                });
            } else {
                this.setState({
                    coordinatorFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting coordinator list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET EMPLOYEE LIST
    apiCallToGetEmployeeList = async () => {
        this.setState({
            employeeFetching: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "department":'',
            "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'getEmployeeDetails',
            requestData,
            '/api/employee/employee.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetEmployeeList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    employeeFetching: false,
                    employeeList: apiResult
                });
            } else {
                this.setState({
                    employeeFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting employee list. Please try again later.'
                });
            }
        }
    }

    // API CALL METHOD TO GET MODULE LIST
    apiCallToGetModuleListWithDemoPoint = async (selectedModuleId) => {
        this.setState({
            moduleFetching: true
        });

        let requestData = {
            "iid": config.institute_id,
            "filter_module": selectedModuleId,
            // "search": this.state.searchTerm
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetHelpDeskModuleListWithPoints',
            requestData,
            '/api/helpDesk/employee/moduleInformation.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetModuleListWithDemoPoint()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                
                this.setState({
                    moduleFetching: false,
                    moduleListWithDemoPoint: apiResult,
                    detailedModuleList: apiResult
                },
                    () => this.setModuleDemoPointData(selectedModuleId)
                );
            } else {
                this.setState({
                    moduleFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting module list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO GET INSTITUTE STREAM LIST
    getInstituteStreamList = async () => {
        let requestData = {
            "iid": config.institute_id,
            'sidArray':[]
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getInstituteStreamList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                Object.keys(apiResult).map((streamId, index) => {
                    apiResult[streamId]['streamId'] = streamId;
                });

                this.setState({
                    departmentList: apiResult,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting institute stream list. Please try again later.'
                });
            }
        }
    }

    // METHOD TO GET FILTER NAME TO SEARCH
    getSearchInputName = (e) => {
        this.setState({
            filterName: e.target.value
        });
    }

    // METHOD TO GET COORDINATOR LIST ACCORDING TO FILTER
    getCoordinatorListByName = (e) => {
        if(e.charCode == 13) {
            this.apiCallToGetCoordinatorList();
        }
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR COORDINATOR LIST
    exportCoordinatorData = () => {
        document.getElementById('exportCoordinator').click();
    }

    // METHOD TO RETURN ADD COORDINATOR MODAL
    returnAddCoordinator = () => {
        return(
            <div id="addCoordinatorSlider" style={{ display: this.state.addCoordinator ? 'flex' : 'none' }}>
                <div id="addCoordinatorDataContainer">
                    <div id="addCoordinatorHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddCoordinator()} style={{ cursor: "pointer" }} />
                        <h5 className="col-11">Add Coordinator</h5>
                    </div>
                    <div id="addCoordinatorBody" className="col-md-12">
                        <div className="selectModule">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Select Module <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                placeholder="Click here to select module"
                                className="form-control addCoordinatorInput"
                                value={this.state.selectedModuleName}
                                readOnly
                                onClick={() => this.setState({ selectModule: true })}
                            />
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.moduleWarning}</p>
                        </div>
                        <div className="selectEmployee">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Select Employee <span style={{ color: 'red' }}>*</span></label>
                            <input
                                type="text"
                                placeholder="Click here to select employee"
                                className="form-control addCoordinatorInput"
                                value={this.state.employeeList[this.state.selectedEmployeeId] != undefined ? this.state.employeeList[this.state.selectedEmployeeId].FirstName + ' ' + this.state.employeeList[this.state.selectedEmployeeId].LastName : ''}
                                readOnly
                                onClick={() => this.setState({ selectEmployee: true })}
                            />
                            <p className="text-danger" style={{ fontSize: 14 }}>{this.state.employeeWarning}</p>
                        </div>
                        <div className="selectDepartment">
                            <label style={{ textTransform: 'none', marginBottom: 0, fontSize: 14 }} className="text-muted">Branch</label>
                            <div className="branchList">
                                {
                                    Object.keys(this.state.departmentList).length > 0 ?
                                        Object.values(this.state.departmentList).map(department => {
                                            return(
                                                <div className="department">
                                                    <input
                                                        type='checkbox'
                                                        style={{ marginRight: 5 }}
                                                        checked={this.state.selectedDepartmentIds.includes(department.streamId)}
                                                        onChange={() => this.selectDepartment(department.streamId)}
                                                    />
                                                    <span style={{ fontSize: 14 }}>{department.stream_name}</span>
                                                </div>
                                            );
                                        })
                                    :
                                        <p>No department found for the institute.</p>
                                }
                            </div>
                        </div>
                    </div>
                    <div id="addCoordinatorFooter" style={{ marginBottom: 10 }}>
                        {
                            this.state.addingCoordinator &&
                                <ButtonLoader />
                        }
                        <button className="btn btn-primary" onClick={() => this.validateCoordinatorDetails()} disabled={this.state.addingCoordinator}>Add</button>
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddCoordinator()}>Cancel</button>
                    </div>
                </div>
            </div >
        );
    }

    // METHOD TO RETURN PRODUCT HELP
    returnProductHelp = () => {
        
        if(this.props.match != undefined)
        {
            if(this.props.match.params.key == "productDocumentation" && this.state.selectModule == false && Object.keys(this.state.moduleList).length > 0)
            {
                this.setState({
                    selectModule: true
                });
            }
        }
    }

    // METHOD TO RETURN SELECT MODULE MODAL
    returnSelectModule = () => {
        return(
            <div className={this.state.selectModule ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered viewModuleWiseDemoPoint-dialog " >
                    <div className="modal-content viewModuleWiseDemoPoint-content">
                        <div className="modal-header">
                            {
                                this.props.match == undefined &&
                                    <div className="icon-container">
                                        <FontAwesomeIcon icon={['fas', 'file-alt']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                                    </div>
                            }
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Select Module</h3>
                            {
                                this.props.match == undefined &&
                                    <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeSelectModule()}/>
                            }
                            
                        </div>
                        <div className="modal-body viewModuleWiseDemoPoint-body">
                            <div className="moduleWisePointContainer">
                                {
                                    this.state.moduleFetching ?
                                        <ButtonLoader />
                                    :
                                    <>  
                                        <div className="col-md-3" style={{padding: "0 15px 0 0"}}>
                                            <div className=" ModuleWisePointListContainer ">
                                                {
                                                    Object.values(this.state.moduleList).map(module => {
                                                        return(
                                                            <div  onClick={(e) => this.selectModule(e, module)} className= {this.state.tempSelectedModule == module.moduleId ? "moduleSelected module" : "module"}>
                                                                <input
                                                                    type='radio'
                                                                    name="module"
                                                                    style={{ marginRight: 5 }}
                                                                    checked={this.state.tempSelectedModule == module.moduleId}
                                                                />
                                                                <span>{module.module_name}</span>
                                                            </div>
                                                        );
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="subModuleDemoPointContainer col-md-9">  
                                            {
                                                this.state.moduleListWithDemoPoint[this.state.tempSelectedModule] &&
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div className = "moduleNameContainer">
                                                            {this.state.moduleListWithDemoPoint[this.state.tempSelectedModule]["module_name"] + " | SubModule and its features"}
                                                            {/* <span onClick={ () => this.getDemoPointAttachment() }>.</span> */}
                                                        </div>
                                                        <p className="detailedPresentation" onClick={() => this.setState({ detailedPresentation: true })}>
                                                            View Detailed Presentation
                                                            <FontAwesomeIcon icon={['fas', 'external-link-square-alt']} size="lg" style={{ marginLeft: 5 }} />
                                                        </p>
                                                        <FontAwesomeIcon icon={['fas', 'copy']} title="Copy presentation URL" size="md" style={{ marginLeft: 10, color: '#818181', cursor: 'pointer' }} onClick={ () => this.copyPresentationUrl(this.state.tempSelectedModule) } />
                                                    </div>
                                            }
                                            <div className="col-md-12">
                                            {
                                                this.state.moduleListWithDemoPoint[this.state.tempSelectedModule] != undefined &&
                                                    Object.values( this.state.moduleListWithDemoPoint[this.state.tempSelectedModule]["subModules"]).length > 0 ? 
                                                        Object.values( this.state.moduleListWithDemoPoint[this.state.tempSelectedModule]["subModules"]).map((subModule,SubModuleIndex) =>{
                                                            return(
                                                                <div style={{ marginBottom: 10 }}>
                                                                    <div style={{fontWeight:'bold'}}>{SubModuleIndex+1}. <span style={{textDecoration:"underLine"}}>{subModule.module_name}</span></div>
                                                                    
                                                                        <div className= "col-md-12">
                                                                        {
                                                                            subModule["demoPointSequence"].map((demoPointId,demoPointIndex) =>{
                                                                                let demoPoint = subModule['demo_point'][demoPointId]
                                                                                return(

                                                                                    <div>{ReactHtmlParser(demoPoint.point)}</div>
                                                                                )
                                                                            })
                                                                        }
                                                                        </div>
                                                                </div>
                                                            )
                                                        })
                                                :
                                                    (this.state.tempSelectedModule != undefined && this.state.tempSelectedModule.length < 1) ?
                                                        <p style={{ color: '#818181', fontSize: 14 }}>Please select module to get sub module details.</p>
                                                    :
                                                        <p style={{ color: '#818181', fontSize: 14 }}>Sub module is not added for {this.state.tempSelectedModuleName}.</p>
                                            }
                                            </div>                                    
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        {
                            this.props.match == undefined &&
                                <div className="modal-footer">
                                    <button className="btn primary-button" onClick={() => this.confirmModuleSelection()}>Select</button>
                                    <button className="btn outline-button" onClick={() => this.closeSelectModule()}>Cancel</button>
                                </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
    
    // METHOD TO SELECT MODULE DETAILS
    // selectModule = (e, module) => {
    //     let attachmentArray = this.state.attachmentArray;
    //     let moduleListWithDemoPoint = this.state.moduleListWithDemoPoint;
    //     let subModuleNameObject = this.state.subModuleNameObject;
    //     let currentPointNameObject = this.state.currentPointNameObject;

    //     subModuleNameObject = {};
    //     currentPointNameObject = {};

    //     attachmentArray = [];

    //     if(moduleListWithDemoPoint[module.moduleId] != undefined)
    //     {
    //         let subModules = moduleListWithDemoPoint[module.moduleId]['subModules'];

    //         if(Object.keys(subModules).length > 0)
    //         {
    //             Object.values(subModules).map(subModule => {
    //                 let demoPoint = subModule.demo_point;

    //                 if(Object.keys(demoPoint).length > 0)
    //                 {
    //                     Object.keys(demoPoint).map(pointId => {
    //                         let point = demoPoint[pointId];
    //                         let attachmentPath = point.attachmentPath != undefined ? point.attachmentPath : "";
    //                         let attachment = point.attachments != "" && point.attachments != null ? point.attachments.split(",") : [];

    //                         if(attachment.length > 0)
    //                         {
    //                             attachment.map(file => {
    //                                 let fileName = attachmentPath+"/"+file;

    //                                 attachmentArray.push(fileName);
    //                             })
    //                         } 
    //                     });
    //                 }
    //             });
    //         }
    //     }

    //     if(moduleListWithDemoPoint[module.moduleId] != undefined) {
    //         let subModules = moduleListWithDemoPoint[module.moduleId]['subModules'];

    //         if(Object.keys(subModules).length > 0) {
    //             Object.keys(subModules).map((subModuleId, subModuleIndex) => {
    //                 if(subModuleIndex == 0) {
    //                     if(Object.keys(subModules[subModuleId].demo_point).length > 0) {
    //                         Object.keys(subModules[subModuleId].demo_point).map((pointId, pointIndex) => {
    //                             if(pointIndex == 0) {
    //                                 let attachments = subModules[subModuleId].demo_point[pointId].attachments;
    //                                 let attachmentArray = attachments == null ? [] : attachments.split(',');

    //                                 this.setState({
    //                                     currentAttachmentArray: attachmentArray,
    //                                     currentAttachmentPath: subModules[subModuleId].demo_point[pointId].attachmentPath,
    //                                     currentAttachmentIdx: 0,
    //                                     currentPointId: pointId,
    //                                     currentPointIds: Object.keys(subModules[subModuleId].demo_point),
    //                                     currentPointIndex: pointIndex
    //                                 });
    //                             }

    //                             currentPointNameObject[pointId] = subModules[subModuleId].demo_point[pointId].point;
    //                         });

    //                         this.setState({
    //                             currentSubModuleId: subModuleId,
    //                             currentSubModuleIndex: subModuleIndex
    //                         });
    //                     }else {
    //                         this.setState({
    //                             currentSubModuleId: subModuleId,
    //                             currentSubModuleIndex: subModuleIndex
    //                         }, () => {
    //                             // METHOD TO GET NEXT SUBMODULE DETAILS
    //                             this.setNextSubModuleDemoPointDetails();
    //                         });
    //                     }
    //                 }

    //                 subModuleNameObject[subModuleId] = subModules[subModuleId].module_name;
    //             });
    //         }

    //         this.setState({
    //             subModuleIds: Object.keys(subModules),
    //             currentSubModuleObject: subModules
    //         });
    //     }else {
    //         this.setState({
    //             currentAttachmentArray: [],
    //             currentAttachmentPath: ''
    //         });
    //     }

    //     this.setState({
    //         tempSelectedModule: module.moduleId,
    //         tempSelectedModuleName: module.module_name,
    //         currentModuleId: module.moduleId,
    //         currentModuleName: module.module_name,
    //         attachmentArray,
    //         subModuleNameObject,
    //         currentPointNameObject
    //     });
    // }

    // METHOD TO SELECT MODULE DETAILS
    selectModule = (e, module) => {
        
        this.apiCallToGetModuleListWithDemoPoint(module.moduleId);

        this.setState({
            tempSelectedModule: module.moduleId,
            tempSelectedModuleName: module.module_name,
            currentModuleId: module.moduleId,
            currentModuleName: module.module_name
        });
    }

    // METHOD TO SET MODULE DEMO POINT DETAILS
    setModuleDemoPointData = (moduleId) => {
        let attachmentArray = this.state.attachmentArray;
        let moduleListWithDemoPoint = this.state.moduleListWithDemoPoint;
        let subModuleNameObject = this.state.subModuleNameObject;
        let currentPointNameObject = this.state.currentPointNameObject;

        subModuleNameObject = {};
        currentPointNameObject = {};

        attachmentArray = [];

        if(moduleListWithDemoPoint[moduleId] != undefined)
        {
            let subModules = moduleListWithDemoPoint[moduleId]['subModules'];

            if(Object.keys(subModules).length > 0)
            {
                Object.values(subModules).map(subModule => {
                    let demoPoint = subModule.demo_point;

                    if(Object.keys(demoPoint).length > 0)
                    {
                        Object.keys(demoPoint).map(pointId => {
                            let point = demoPoint[pointId];
                            let attachmentPath = point.attachmentPath != undefined ? point.attachmentPath : "";
                            let attachment = point.attachments != "" && point.attachments != null ? point.attachments.split(",") : [];

                            if(attachment.length > 0)
                            {
                                attachment.map(file => {
                                    let fileName = attachmentPath+"/"+file;

                                    attachmentArray.push(fileName);
                                })
                            } 
                        });
                    }
                });
            }
        }

        if(moduleListWithDemoPoint[moduleId] != undefined) {
            let subModules = moduleListWithDemoPoint[moduleId]['subModules'];

            if(Object.keys(subModules).length > 0) {
                Object.keys(subModules).map((subModuleId, subModuleIndex) => {
                    if(subModuleIndex == 0) {
                        if(Object.keys(subModules[subModuleId].demo_point).length > 0) {
                            Object.keys(subModules[subModuleId].demo_point).map((pointId, pointIndex) => {
                                if(pointIndex == 0) {
                                    let attachments = subModules[subModuleId].demo_point[pointId].attachments;
                                    let attachmentArray = attachments == null ? [] : attachments.split(',');

                                    this.setState({
                                        currentAttachmentArray: attachmentArray,
                                        currentAttachmentPath: subModules[subModuleId].demo_point[pointId].attachmentPath,
                                        currentAttachmentIdx: 0,
                                        currentPointId: pointId,
                                        currentPointIds: Object.keys(subModules[subModuleId].demo_point),
                                        currentPointIndex: pointIndex
                                    });
                                }

                                currentPointNameObject[pointId] = subModules[subModuleId].demo_point[pointId].point;
                            });

                            this.setState({
                                currentSubModuleId: subModuleId,
                                currentSubModuleIndex: subModuleIndex
                            });
                        }else {
                            this.setState({
                                currentSubModuleId: subModuleId,
                                currentSubModuleIndex: subModuleIndex
                            }, () => {
                                // METHOD TO GET NEXT SUBMODULE DETAILS
                                this.setNextSubModuleDemoPointDetails();
                            });
                        }
                    }

                    subModuleNameObject[subModuleId] = subModules[subModuleId].module_name;
                });
            }

            this.setState({
                subModuleIds: Object.keys(subModules),
                currentSubModuleObject: subModules
            });
        }else {
            this.setState({
                currentAttachmentArray: [],
                currentAttachmentPath: ''
            });
        }

        this.setState({
            attachmentArray,
            subModuleNameObject,
            currentPointNameObject
        });
    }

    // METHOD TO GET DEMO POINT ATTACHMENT
    getDemoPointAttachment = () => {
        let attachmentArray = this.state.attachmentArray;
        
        this.setState({
            viewAttachment: true,
            currentAttachmentIndex: 0,
            selectedAttachmentFile: attachmentArray[0] != undefined ? attachmentArray[0] : ""
        });
    }

    // METHOD TO RETURN DEMO POINT ATTACHMENT MODAL
    returnDemoPointAttachment = () => {
        return(
            <div className={this.state.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-lg" style={{ minWidth: '98%', height: '98%' }}>
                    <div className="modal-content" style={{ height: '95%' }}>
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'file-alt']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>{"Demo Point Attachment"}</h3>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeDemoPointAttachment()} />
                        </div>
                        <div className="modal-body demoPointAttachment">
                            {
                                this.state.selectedAttachmentFile != "" ?
                                    <div className='attachmentContainer'>
                                        <img src={this.state.selectedAttachmentFile} width='95%' ></img>
                                    </div>
                                :
                                    <span>Attachments not yet added for the module's demo point.</span>
                            }
                        </div>
                        <div className="modal-footer attachmentFooter">
                            <div className="queryShift">
                                <FontAwesomeIcon icon={['fas', 'chevron-circle-left']} style={{ opacity: (this.state.currentAttachmentIndex == 0) ? 0.5 : 1, cursor: 'pointer' }} size="lg" color="#0465AC" onClick={(e) => (this.state.currentAttachmentIndex == 0) ? e.preventDefault() : this.getPreviousAttachment()} /> 
                                <span style={{ margin: '0px 15px' }}>{this.state.currentAttachmentIndex + 1}</span>
                                <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} style={{ opacity: (this.state.attachmentArray.length == 0 || (this.state.currentAttachmentIndex == (this.state.attachmentArray.length -1))) ? 0.5 : 1, cursor: 'pointer' }} size="lg" color="#0465AC" onClick={(e) => (this.state.attachmentArray.length == 0 || (this.state.currentAttachmentIndex == (this.state.attachmentArray.length -1))) ? e.preventDefault() : this.getNextAttachment()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO GET PREVIOUS ATTACHMENT
    getPreviousAttachment = () => {
        let currentAttachmentIndex = this.state.currentAttachmentIndex;
        let attachmentArray = this.state.attachmentArray;

        this.setState({
            viewAttachment: true,
            currentAttachmentIndex: currentAttachmentIndex - 1,
            selectedAttachmentFile: attachmentArray[parseInt(currentAttachmentIndex) - 1] != undefined ? attachmentArray[parseInt(currentAttachmentIndex) - 1] : ""
        });
    }

    // METHOD TO GET NEXT ATTACHMENT
    getNextAttachment = () => {
        let currentAttachmentIndex = this.state.currentAttachmentIndex;
        let attachmentArray = this.state.attachmentArray;

        this.setState({
            viewAttachment: true,
            currentAttachmentIndex: currentAttachmentIndex + 1,
            selectedAttachmentFile: attachmentArray[parseInt(currentAttachmentIndex) + 1] != undefined ? attachmentArray[parseInt(currentAttachmentIndex) + 1] : ""
        });
    }

    // METHOD TO CLOSE DEMO POINT ATTACHMENT VIEW
    closeDemoPointAttachment = () => {
        let module
        this.setState({
            viewAttachment: false,
            currentAttachmentIndex: 0,
            selectedAttachmentFile: ''
        })
    }

    // METHOD TO CONFIRM MODULE SELECTION
    confirmModuleSelection = () => {
        if(this.state.tempSelectedModule.length < 1) {
            this.setState({
                moduleWarning: 'Please select module.'
            });
        }else {
            this.setState({
                moduleWarning: ''
            });
        }

        this.setState({
            selectModule: false,
            selectedModule: this.state.tempSelectedModule,
            selectedModuleName: this.state.tempSelectedModuleName
        });
    }

    // METHOD TO CLOSE SELECT MODULE MODAL
    closeSelectModule = () => {
        this.setState({
            selectModule: false,
            tempSelectedModule: this.state.selectedModule,
            tempSelectedModuleName: this.state.selectedModuleName
        });
    }

    // METHOD TO RETURN SELECT EMPLOYEE MODAL
    returnSelectEmployee = () => {
        return(
            <div className={this.state.selectEmployee ? "modal fade show" : "modal fade"} id="modalContainer" >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'user']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <h3 style={{ textTransform: "capitalize", fontSize: 20 }}>Select Employees</h3>
                            <FontAwesomeIcon icon={['fas', 'times']} style={{ cursor: 'pointer' }} size="lg" color="#000000" onClick={() => this.closeSelectEmployees()}/>
                        </div>
                        <div className="modal-body selectEmployees-body">
                            <div className="searchName">
                                <FontAwesomeIcon icon={['fas', 'search']} color="#495057" className="search-icon" />
                                <input
                                    type="text"
                                    className="form-control searchInput"
                                    placeholder="Search employee" 
                                    onChange={(e)=>this.setState({ searchTerm: e.target.value })} 
                                    value={this.state.searchTerm}
                                    onKeyPress={(e) => this.searchEmployee(e)}
                                />
                            </div>
                            <p className="info-msg">Press enter to search.</p>
                            <div className="employeeList">
                                <table className="table table-bordered table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th style={{ padding: 5 }}></th>
                                            <th style={{ padding: 5 }}>Sr. No.</th>
                                            <th style={{ padding: 5 }}>Designation</th>
                                            <th style={{ padding: 5 }}>First Name</th>
                                            <th style={{ padding: 5 }}>Last Name</th>
                                            <th style={{ padding: 5 }}>Role</th>
                                            <th style={{ padding: 5 }}>Email Id</th>
                                            <th style={{ padding: 5 }}>Mobile Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.employeeFetching ?
                                                <tr>
                                                    <td style={{ padding: 5 }} colSpan={8}>
                                                        <ButtonLoader />
                                                    </td>
                                                </tr>
                                            :
                                                Object.keys(this.state.employeeList).length > 0 ?
                                                    Object.values(this.state.employeeList).map((employee, employeeIndex) => {
                                                        return(
                                                            <tr key={employee.FacultyId}>
                                                                <td style={{ padding: 5 }}>
                                                                    <input
                                                                        type='radio'
                                                                        name="employee"
                                                                        style={{ marginRight: 5 }}
                                                                        checked={this.state.tempSelectedEmployeeId == employee.FacultyId}
                                                                        onClick={(e) => this.selectEmployeeDetails(employee.FacultyId)}
                                                                    />
                                                                </td>
                                                                <td style ={{ padding: 5 }}>{employeeIndex + 1}.</td>
                                                                <td style ={{ padding: 5 }}>{employee.designation}</td>
                                                                <td style ={{ padding: 5 }}>{employee.FirstName}</td>
                                                                <td style ={{ padding: 5 }}>
                                                                    <span>{employee.LastName} |</span>
                                                                    <span  style={{marginLeft:5 ,color:employee.status == "active" ? " #219653" :" #eb5757"}}>{employee.status}</span>                                                                    
                                                                </td>
                                                                <td style ={{ padding: 5 }}>{employee.employeeRole}</td>
                                                                <td style ={{ padding: 5 }}>{employee.email_id}</td>
                                                                <td style ={{ padding: 5 }}>{employee.mobile_no}</td>
                                                            </tr>
                                                        );
                                                    })
                                                :
                                                    <tr>
                                                        <td style={{ padding: 5 }}>No employee details found.</td>
                                                    </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn primary-button" onClick={() => this.confirmEmployeeSelection()}>Select</button>
                            <button className="btn outline-button" onClick={() => this.closeSelectEmployees()}>Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SEARCH EMPLOYEE
    searchEmployee = (e) => {
        if(e.charCode == 13) {
            this.apiCallToGetEmployeeList();
        }
    }
    
    // METHOD TO SELECT EMPLOYEE DETAILS
    selectEmployeeDetails = (employeeId) => {
        this.setState({
            tempSelectedEmployeeId: employeeId,
        });
    }

    // METHOD TO CONFIRM EMPLOYEE SELECTION
    confirmEmployeeSelection = () => {
        this.setState({
            selectedEmployeeId: this.state.tempSelectedEmployeeId
        });
        
        if(this.state.tempSelectedEmployeeId.length < 1) {
            this.setState({
                employeeWarning: 'Please select employee.'
            });
        }else {
            this.setState({
                employeeWarning: ''
            });
        }

        this.setState({
            selectEmployee: false,
        });
    }

    // METHOD TO CLOSE SELECT EMPLOYEE MODAL
    closeSelectEmployees = () => {
        this.setState({
            selectEmployee: false,
            tempSelectedEmployeeId: this.state.selectedEmployeeId,
        });
    }

    // METHOD TO SELECT DEPARTMENT
    selectDepartment = (departmentId) => {
        let selectedDepartmentIds = this.state.selectedDepartmentIds;
        if(selectedDepartmentIds.includes(departmentId)) {
            selectedDepartmentIds = selectedDepartmentIds.filter(streamId => streamId != departmentId);
        }else {
            selectedDepartmentIds.push(departmentId);
        }

        this.setState({
            selectedDepartmentIds
        });
    }

    // METHOD TO VALIDATE COORDINATOR DETAILS
    validateCoordinatorDetails = () => {
        let validData = true;

        if(this.state.selectedModule.length < 1) {
            this.setState({
                moduleWarning: 'Please select module.'
            });
            validData = false;
        }

        if(this.state.selectedEmployeeId.length < 1) {
            this.setState({
                employeeWarning: 'Please select employee.'
            });
            validData = false;
        }

        if(validData) {
            this.apiCallToAddCoordinator();
        }
    }

    // API CALL METHOD TO ADD COORDINATOR
    apiCallToAddCoordinator = async () => {
        this.setState({
            addingCoordinator: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "module_id": this.state.selectedModule,
            "coordinator_id": this.state.selectedEmployeeId,
            "added_by": config.faculty_id,
            'sidArray': this.state.selectedDepartmentIds
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'AddPMCoordinatorWithMultipleBrach',
            requestData,
            '/api/projectManagement/client/coordinator.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddCoordinator()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    let coordinatorList = this.state.coordinatorList;
                    let moduleList = this.state.moduleList;
                    let employeeList = this.state.employeeList;
                    if(coordinatorList[this.state.selectedModule] == undefined) {
                        coordinatorList[this.state.selectedModule] = {};
                        coordinatorList[this.state.selectedModule]["moduleId"] = this.state.selectedModule;
                        coordinatorList[this.state.selectedModule]["moduleName"] = moduleList[this.state.selectedModule]["module_name"];
                        coordinatorList[this.state.selectedModule]["coordinatorObj"] =[];
                    }
                    // let coordinatorObject = {};

                    if(apiResult.inserted_employee.length > 0) {
                        apiResult.inserted_employee.map(insertedObj => {
                            let {sid,insert_id} = insertedObj;
                            let {FirstName,LastName,Role,designation,email_id,employeeRole,mobile_no,status} = employeeList[this.state.selectedEmployeeId];

                            if( coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId] == undefined) {
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId] = {};
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['sidArray'] = {}; 
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['employeeId'] = this.state.selectedEmployeeId;                                                           
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['coordinationUID'] = insert_id;
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['employeeName'] = FirstName+" "+LastName;
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['employeeDesignation'] = designation;
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['employeeRole'] = employeeRole;
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['employeeStatus'] = status;
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['employeeEmail'] = email_id;
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['employeeMobileNo'] = mobile_no;
                            }
                            
                            if(sid != "")
                            {
                                
                                if( coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['sidArray'][sid] == undefined) {
                                    coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['sidArray'][sid] = {};
                                }
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['sidArray'][sid]['streamName'] = this.state.departmentList[sid].stream_name;
                                coordinatorList[this.state.selectedModule].coordinatorObj[this.state.selectedEmployeeId]['sidArray'][sid]['coordinationUID'] = insertedObj.insert_id;
                            }
                           
                        });
                    }
                    // coordinatorList[this.state.selectedModule]['module_name'] = this.state.selectedModuleName;
                    // coordinatorList[this.state.selectedModule]['module_id'] = this.state.selectedModule;
                    // coordinatorList[this.state.selectedModule]['coordinatorObj'] = coordinatorObject;
                    this.closeAddCoordinator();
                    this.setState({
                        addingCoordinator: false,
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        coordinatorList,
                        coordinatorCount: this.state.coordinatorCount + apiResult.inserted_employee.length
                    });
                }else {
                    this.setState({
                        addingCoordinator: false,
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    coordinatorFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding coordinator. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE ADD COORDINATOR
    closeAddCoordinator = () => {
        this.setState({
            addCoordinator: false,
            addingCoordinator: false,
            selectModule: false,
            tempSelectedModule: '',
            tempSelectedModuleName: '',
            selectedModule: '',
            selectedModuleName: '',
            moduleWarning: '',
            selectEmployee: false,
            tempSelectedEmployeeId: '',
            tempSelectedEmployeeName: '',
            selectedEmployeeId: '',
            selectedEmployeeName: '',
            selectedDepartmentIds: [],
            employeeWarning: '',

        });
    }   

    // METHOD TO REMOVE COORDINATOR
    removeCoordinator = (moduleId, coordinator) => {
        this.setState({
            deleteCoordinator: true,
            moduleUniqueId: moduleId,
            coordinatorId: coordinator.coordinationUID
        });
    }

    // API CALL METHOD TO DELETE COORDINATOR 
    apiCallToDeleteCoordinator = async () => {
        let requestData = {
            "institute_id": config.institute_id,
            "module_id": this.state.moduleUniqueId,
            "removed_coordinationUID_array": [this.state.coordinatorId],
            "updated_by": config.faculty_id
        };

        let jsonResponse = await HelpdeskApiCall.makeApiCall(
            'removePMCoordinator',
            requestData,
            '/api/projectManagement/client/coordinator.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToDeleteCoordinator()
            }, 1000);
        } else {
            this.closeDeleteCoordinator();
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if(apiResult.status == 'success') {
                    let deletedCoordinationId = this.state.coordinatorId;
                    let coordinatorList = this.state.coordinatorList;
                    let moduleUniqueId = this.state.moduleUniqueId;
                    
                    Object.values(coordinatorList).map(function(ModuleObj, ModuleIndex) {
                        let deleteCoordinatorId = "";
                        Object.values(ModuleObj["coordinatorObj"]).map(function(coordinatorObj, coordinatorIndex) {
                            // check if only one stream is added 
                            let coordinatorId = coordinatorObj["employeeId"];
                            if(Object.keys(coordinatorObj["sidArray"]).length < 2 && coordinatorObj.coordinationUID == deletedCoordinationId)
                            {
                                deleteCoordinatorId = coordinatorId;
                            }else{
                                let DeleteSID= "";
                                for(var sid in coordinatorObj["sidArray"])
                                {
                                    if(coordinatorObj["sidArray"][sid]["coordinationUID"] == deletedCoordinationId)
                                    {
                                        DeleteSID = sid;
                                    }
                                }
                                if(DeleteSID != '')
                                {
                                    delete coordinatorList[moduleUniqueId].coordinatorObj[coordinatorId]["sidArray"][DeleteSID];
                                }
                                
                            }
                        });
                        
                        if(deleteCoordinatorId != '')
                        {
                            delete coordinatorList[moduleUniqueId].coordinatorObj[deleteCoordinatorId];
                        }
                        
                    })
                    
                    // if(Object.keys(coordinatorList[this.state.moduleUniqueId].coordinatorObj).length < 1) {
                    //     delete coordinatorList[this.state.moduleUniqueId];
                    // }

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        coordinatorList,
                        coordinatorCount: this.state.coordinatorCount - 1
                    });
                }else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    coordinatorFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting coordinator. Please try again later.'
                });
            }
        }
    }

    // METHOD TO CLOSE DELETE COORDINATOR
    closeDeleteCoordinator = () => {
        this.setState({
            deleteCoordinator: false
        });
    }

    // METHOD TO UPDATE PAGINATION COUNT
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit
        }, () => {
            this.apiCallToGetCoordinatorList();
        });
    }

    // // METHOD TO RETURN VIEW DETAILED PRESENTATION
    // returnViewDetailedPresentation = () => {
    //     return(
    //         <div className={this.state.detailedPresentation ? "modal fade show" : "modal fade"} id="modalContainer" >
    //             <div className="modal-dialog viewDetailedPresentation-dialog">
    //                 <div className="modal-content viewDetailedPresentation-content">
    //                     <div className="modal-body viewDetailedPresentation-body">
    //                         <div className="detailedPresentationContainer">
    //                             {
    //                                 this.state.collapseStatus == 'expanded' ?
    //                                     <div className='detailedPresentationPoint' id="detailedPointContainer">
    //                                         <div className="tableContentHeader">
    //                                             <p>Table of Content for {this.state.currentModuleName}</p>
    //                                             <FontAwesomeIcon icon={['fas', 'angle-double-left']} size="lg" color="#B4B4BB" style={{ cursor: 'pointer' }} onClick={() => this.setState({ collapseStatus: 'collapsed' })} />
    //                                         </div>
    //                                         <div className="subModuleListContainer">
    //                                             {
    //                                                 Object.keys(this.state.currentSubModuleObject).length > 0 ?
    //                                                     Object.values(this.state.currentSubModuleObject).map((subModule, subModuleIndex) => {
    //                                                         return(
    //                                                             <div className="subModulePointDetails">
    //                                                                 <p className="detailedSubModuleName">{subModuleIndex + 1}. {subModule.module_name}</p>
    //                                                                 <div className="pointListDetails">
    //                                                                     {
    //                                                                         Object.keys(subModule.demo_point).length > 0 &&
    //                                                                             Object.values(subModule.demo_point).map((point, pointIndex) => {
    //                                                                                 return(
    //                                                                                     <>
    //                                                                                         <p className={this.state.currentPointId == point.unique_id ? 'selectedPointName detailedPointName' : "detailedPointName"} onClick={() => this.setCurrentPoint(subModule.unique_id, subModuleIndex, point.unique_id, pointIndex)}>{ReactHtmlParser(point.point)}</p>
    //                                                                                     </>
    //                                                                                 );
    //                                                                             })
    //                                                                     }
    //                                                                 </div>
    //                                                             </div>
    //                                                         );
    //                                                     })
    //                                                 :
    //                                                     <p style={{ fontSize: 14, marginTop: 20, color: '#818181' }}>No sub module is yet added to <span style={{ fontWeight: 'bold' }}>{this.state.currentModuleName}</span>.</p>
    //                                             }
    //                                         </div>
    //                                     </div>
    //                                 :
    //                                     <div className='detailedPresentationPointCollapsed' id="detailedPointContainer">
    //                                         <FontAwesomeIcon icon={['fas', 'angle-double-right']} style={{ cursor: 'pointer' }} size="lg" color="#B4B4BB" onClick={() => this.setState({ collapseStatus: 'expanded' })} />
    //                                     </div>
    //                             }
    //                             <div className={this.state.collapseStatus == 'expanded' ? "detailedPresentationAttachment" : "detailedPresentationAttachmentFull"}>
    //                                 <div className="attachmentHeader">
    //                                     {this.state.currentSubModuleIndex + 1}.
    //                                     <span style={{ borderRight: this.state.subModuleNameObject[this.state.currentSubModuleId] ? '1px solid #818181' : 'none', paddingRight: 10 }}>{this.state.currentModuleName}</span>
    //                                     {
    //                                         this.state.subModuleNameObject[this.state.currentSubModuleId] &&
    //                                             <span>{this.state.subModuleNameObject[this.state.currentSubModuleId]}</span>
    //                                     }
    //                                 </div>
    //                                 <div className="detailedAttachmentView">
    //                                     {   
    //                                         this.state.currentAttachmentArray.length > 0 ?
    //                                             <img src={this.state.currentAttachmentPath + '/' + this.state.currentAttachmentArray[this.state.currentAttachmentIdx]} width="100%" height="100%" />
    //                                         :
    //                                             <p style={{ marginTop: 30, fontSize: 14, color: '#818181' }}>Content not available.</p>
    //                                     }
    //                                 </div>
    //                                 <div className={this.state.collapseStatus == 'collapsed' ? 'attachmentActionButtonsFull' : 'attachmentActionButtons'}>
    //                                     <div className="nextPreviousButtons">
    //                                         <FontAwesomeIcon icon={['fas', 'chevron-circle-left']} size="lg" color="#0465AC" style={{ cursor: 'pointer', opacity: (Object.keys(this.state.currentSubModuleObject).length == 0 || this.state.currentPointIds.length == 0 || (this.state.currentSubModuleIndex == 0 && this.state.currentPointIndex == 0 && this.state.currentAttachmentIdx == 0)) ? 0.5 : 1 }} onClick={(e) => (Object.keys(this.state.currentSubModuleObject).length == 0 || this.state.currentPointIds.length == 0 || (this.state.currentSubModuleIndex == 0 && this.state.currentPointIndex == 0 && this.state.currentAttachmentIdx == 0)) ? e.preventDefault() : this.getPreviousPresentation()} />
    //                                         <FontAwesomeIcon icon={['fas', 'chevron-circle-right']} size="lg" color="#0465AC" style={{ cursor: 'pointer', opacity: (Object.keys(this.state.currentSubModuleObject).length == 0 || ((parseInt(this.state.subModuleIds[this.state.subModuleIds.length - 1]) == this.state.currentSubModuleId) && (parseInt(this.state.currentPointIds[this.state.currentPointIds.length - 1]) == this.state.currentPointId) && (this.state.currentAttachmentIdx == (this.state.currentAttachmentArray.length == 0 ? this.state.currentAttachmentArray.length : this.state.currentAttachmentArray.length - 1)))) ? 0.5 : 1}} onClick={(e) => (Object.keys(this.state.currentSubModuleObject).length == 0 || ((parseInt(this.state.subModuleIds[this.state.subModuleIds.length - 1]) == this.state.currentSubModuleId) && (parseInt(this.state.currentPointIds[this.state.currentPointIds.length - 1]) == this.state.currentPointId) && (this.state.currentAttachmentIdx == (this.state.currentAttachmentArray.length == 0 ? this.state.currentAttachmentArray.length : this.state.currentAttachmentArray.length - 1)))) ? e.preventDefault() : this.getNextPresentation()} />
    //                                     </div>
    //                                     {
    //                                         this.props.match == undefined && 
    //                                             <div className="closeViewButtonContainer">
    //                                                 <p className="closeViewButton" onClick={() => this.closeDetailedPresentation()}>
    //                                                     Close
    //                                                 </p>
    //                                             </div>
    //                                     }
                                        
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </div>
    //     );
    // }

     // METHOD TO RETURN VIEW DETAILED PRESENTATION
     returnViewDetailedPresentation = () => {
        return(
            <div className={this.state.detailedPresentation ? "modal fade show" : "modal fade"} id="modalContainer" >
                
                <div className="modal-dialog viewDetailedPresentation-dialog">
                    <div className="modal-content viewDetailedPresentation-content">
                        <div className="modal-body viewDetailedPresentation-body">
                            <div className="detailedPresentationContainer">
                                {
                                    this.state.detailedPresentation && 
                                        <ModulePresentation 
                                            moduleId = {this.state.tempSelectedModule}
                                            source = {"helpDesk"}
                                            closeDetailedPresentation = {this.closeDetailedPresentation}
                                        />
                                }
                                
                                
                                {/* <iframe src={config.RootUrl+"/modules/helpdesk/#/"+toBase64(this.state.tempSelectedModule)} height='100%' width='100%' ></iframe> */}
                                {/* <iframe src={"http://localhost:3000/#/"+toBase64(this.state.tempSelectedModule)} height='100%' width='100%' ></iframe> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO SET CURRENT POINT
    setCurrentPoint = (subModuleId, subModuleIndex, pointId, pointIndex) => {
        let currentSubModuleObject = this.state.currentSubModuleObject;
        let attachmentArray = [];
        let attachmentPath = '';

        if(currentSubModuleObject[subModuleId] != undefined) {
            let pointObject = currentSubModuleObject[subModuleId].demo_point;
            if(pointObject[pointId] != undefined) {
                let pointDetails = pointObject[pointId];

                attachmentPath = pointDetails.attachmentPath;

                if(pointDetails.attachments == undefined || pointDetails.attachments == null) {
                    attachmentArray = [];
                }else {
                    attachmentArray = pointDetails.attachments.split(',');
                }
            }
        }
        
        this.setState({
            currentSubModuleId: subModuleId,
            currentSubModuleIndex: subModuleIndex,
            currentPointId: pointId,
            currentPointIndex: pointIndex,
            currentAttachmentIdx: 0,
            currentPointIds: Object.keys(currentSubModuleObject[subModuleId].demo_point),
            currentAttachmentArray: attachmentArray,
            currentAttachmentPath: attachmentPath
        });
    }

    // METHOD TO SET PREVIOUS SUBMODULE DEMO POINT DETAILS
    setPreviousSubModuleDemoPointDetails = () => {
        let currentSubModuleIndex = this.state.currentSubModuleIndex - 1;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if(this.state.currentSubModuleObject[currentSubModuleId] != undefined) {
            let demoPoints = Object.keys(this.state.currentSubModuleObject[currentSubModuleId].demo_point);

            if(demoPoints.length > 0) {
                let currentPointIndex = demoPoints.length - 1;
                let currentPointId = demoPoints[currentPointIndex];
                
                if(this.state.currentSubModuleObject[currentSubModuleId] != undefined) {
                    let point = this.state.currentSubModuleObject[currentSubModuleId].demo_point[currentPointId];
            
                    let attachments = point.attachments;
                    let attachmentArray = attachments == null ? [] : attachments.split(',');
                    let attachmentPath = point.attachmentPath;

                    this.setState({
                        currentAttachmentArray: attachmentArray,
                        currentSubModuleIndex: currentSubModuleIndex,
                        currentSubModuleId: currentSubModuleId,
                        currentAttachmentPath: attachmentPath,
                        currentAttachmentIdx: attachmentArray.length == 0 ? 0 : attachmentArray.length - 1,
                        currentPointIds: demoPoints,
                        currentPointIndex: currentPointIndex,
                        currentPointId: currentPointId
                    });
                }
            }else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO GET PREVIOUS SUB MODULE DETAILS
                    this.setPreviousSubModuleDemoPointDetails();
                });
            }
        }
    }
    
    // METHOD TO SET NEXT SUBMODULE DEMO POINT DETAILS
    setNextSubModuleDemoPointDetails = () => {
        let currentSubModuleIndex = this.state.currentSubModuleIndex + 1;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if(this.state.currentSubModuleObject[currentSubModuleId] != undefined) {
            let demoPoints = Object.keys(this.state.currentSubModuleObject[currentSubModuleId].demo_point);

            if(demoPoints.length > 0) {
                let currentPointIndex = 0;
                let currentPointId = demoPoints[currentPointIndex];

                let point = this.state.currentSubModuleObject[currentSubModuleId].demo_point[currentPointId];
            
                let attachments = point.attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = point.attachmentPath;

                this.setState({
                    currentAttachmentArray: attachmentArray,
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0,
                    currentPointIds: demoPoints,
                    currentPointIndex: currentPointIndex,
                    currentPointId: currentPointId
                });
            }else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO GET NEXT SUB MODULE DETAILS
                    this.setNextSubModuleDemoPointDetails();
                });
            }
        }
    }

    // VARIABLES TO GET PREVIOUS PRESENTATION
    getPreviousPresentation = () => {
        let currentSubModuleObject = this.state.currentSubModuleObject;
        if(this.state.currentAttachmentIdx == 0) {
            if(this.state.currentPointIndex == 0) {
                if(this.state.currentSubModuleIndex > 0) {
                    this.setPreviousSubModuleDemoPointDetails();
                }
            }else {
                let currentPointIndex = this.state.currentPointIndex - 1;
                let currentPointId = this.state.currentPointIds[currentPointIndex];
                
                let point = currentSubModuleObject[this.state.currentSubModuleId].demo_point[currentPointId];
                
                let attachments = point.attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = point.attachmentPath;

                this.setState({
                    currentAttachmentArray: attachmentArray,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: attachmentArray.length == 0 ? 0 : attachmentArray.length - 1,
                    currentPointIndex: currentPointIndex,
                    currentPointId: currentPointId
                });
            }
        }else {
            this.setState({
                currentAttachmentIdx: this.state.currentAttachmentIdx - 1
            });
        }
    }

    // VARIABLES TO GET NEXT PRESENTATION
    getNextPresentation = () => {
        let currentSubModuleObject = this.state.currentSubModuleObject;
        if(this.state.currentAttachmentIdx == (this.state.currentAttachmentArray.length == 0 ? this.state.currentAttachmentArray.length : (this.state.currentAttachmentArray.length - 1))) {
            if(this.state.currentPointIndex == (this.state.currentPointIds.length - 1)) {
                if(this.state.currentSubModuleIndex != (this.state.subModuleIds.length - 1)) {
                    this.setNextSubModuleDemoPointDetails();
                }
            }else {
                let currentPointIndex = this.state.currentPointIndex + 1;
                let currentPointId = this.state.currentPointIds[currentPointIndex];
                
                let point = currentSubModuleObject[this.state.currentSubModuleId].demo_point[currentPointId];
                
                let attachments = point.attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = point.attachmentPath;

                this.setState({
                    currentAttachmentArray: attachmentArray,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0,
                    currentPointIndex: currentPointIndex,
                    currentPointId: currentPointId
                });
            }
        }else {
            this.setState({
                currentAttachmentIdx: this.state.currentAttachmentIdx + 1
            });
        }
    }

    // METHOD TO CLOSE DETAILED PRESENTATION
    closeDetailedPresentation = () => {
        let currentSubModuleObject = this.state.currentSubModuleObject;

        let currentSubModuleIndex = 0;
        let currentSubModuleId = this.state.subModuleIds[currentSubModuleIndex];

        if(currentSubModuleObject[currentSubModuleId] != undefined) {
            if(Object.keys(currentSubModuleObject[currentSubModuleId].demo_point).length > 0) {
                let demoPoints = Object.keys(currentSubModuleObject[currentSubModuleId].demo_point);

                let currentPointIndex = 0;
                let currentPointId = demoPoints[currentPointIndex];

                let attachments = currentSubModuleObject[currentSubModuleId].demo_point[currentPointId].attachments;
                let attachmentArray = attachments == null ? [] : attachments.split(',');
                let attachmentPath = currentSubModuleObject[currentSubModuleId].demo_point[currentPointId].attachmentPath;

                this.setState({
                    currentSubModuleIndex: 0,
                    currentSubModuleId: currentSubModuleId,
                    currentPointIndex: 0,
                    currentPointId: currentPointId,
                    currentAttachmentArray: attachmentArray,
                    currentAttachmentPath: attachmentPath,
                    currentAttachmentIdx: 0
                });
            }else {
                this.setState({
                    currentSubModuleIndex: currentSubModuleIndex,
                    currentSubModuleId: currentSubModuleId
                }, () => {
                    // METHOD TO SET NEXT SUB MODULE DETAILS
                    this.setNextSubModuleDemoPointDetails();
                });
            }
        }

        this.setState({
            detailedPresentation: false
        });
    }

    // METHOD TO COPY PRESENTATION URL
    copyPresentationUrl = (selectedModuleId) => {
        let presentationUrl = '';

        presentationUrl = config.RootUrl+'/modules/helpdesk/#/'+toBase64(selectedModuleId);

        navigator.clipboard.writeText(presentationUrl);
    }

    returnPresentationData = () => {
        let moduleData = {};
        if(this.props.match != undefined)
        {
            let moduleId = fromBase64(this.props.match.params.module);

            if(Object.keys(this.state.moduleList).length > 0 || this.state.moduleList.length > 0)
            {
                Object.values(this.state.moduleList).map(module => {
                    if(parseInt(module.moduleId) == parseInt(moduleId))
                    {
                        moduleData = module;
                    }
                });
            }
            
            if(Object.keys(moduleData).length > 0 && this.state.detailedPresentation == false && (parseInt(this.state.tempSelectedModule) != parseInt(moduleId)))
            {
                this.setState({
                    detailedPresentation: true
                },
                    (e) => this.selectModule(e, moduleData)
                );
            }
        }
    }
    
    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false,
        });
    }

    // METHOD TO GET PER PAGE LIMIT
    getPerPage = (e) => {
        this.setState({
            pageIndex: 1,
            offset: 0,
            limit: e.target.value
        }, () => {
            this.apiCallToGetCoordinatorList();
        });
    }

    render() {
        return (
            <>
                <div className="coordinatorContainer col-md-12">
                    <div className="link-header">
                        <FontAwesomeIcon icon={['far', 'arrow-alt-circle-left']} size="lg" style={{ marginRight: 10, cursor: 'pointer' }} onClick={() => this.props.closeLinkDetails()} />
                        <p className="header-text">Co-ordinator Management</p>
                    </div>
                    <div className="coordinator-actions">
                        <div className="searchName col-md-4" style={{ paddingLeft: 0 }}>
                            <FontAwesomeIcon icon={['fas', 'search']} color="#495057" className="search-icon" />
                            <input
                                type="text"
                                className="form-control searchInput"
                                placeholder='Search By Module Name'
                                value={this.state.filterName}
                                onChange={(e) => this.getSearchInputName(e)}
                                onKeyPress={(e) => this.getCoordinatorListByName(e)}
                                style={{ fontSize: 14 }}
                            />
                        </div>
                        <div className="addCoordinator-button">
                            <div className="show-results" style={{display:'inline',marginRight:5}}>
                                <span style={{ marginRight: 10 }}>
                                    Show results
                                </span>
                                <span>
                                    <select
                                        className="filterDemoInput"
                                        value={this.state.limit}
                                        onChange={(e) => this.getPerPage(e)}
                                    >
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="40">40</option>
                                        <option value="100">100</option>
                                        <option value="250">250</option>
                                    </select>
                                </span>
                            </div>
                            <div style={{ display: 'none' }}>
                                <ReactHTMLTableToExcel
                                    id="exportCoordinator"
                                    className="btn outline-button waves-effect text-capitalize"
                                    table="coordinatorList"
                                    filename="Module Coordinator List"
                                    sheet="tablexls"
                                    buttonText="Export to Excel "
                                />
                            </div>
                            <FontAwesomeIcon icon={['far', 'file-excel']} size="lg" color="#0465AC" style={{ marginRight: 20, cursor: 'pointer' }} onClick={() => this.exportCoordinatorData()} />
                            <ReactToPrint
                                trigger={() => {
                                    return <FontAwesomeIcon icon={['fas', 'print']} size="lg" color="#0465AC" style={{ marginRight: 20, cursor: 'pointer' }} />;
                                }}
                                content={() => this.printReference}
                            />
                            {
                                this.state.onboardingAccess && 
                                <button
                                    className="btn primary-button addCoordinator"
                                    onClick={() => this.setState({ addCoordinator: true })}
                                >
                                    <FontAwesomeIcon icon={['fas', 'plus']} style={{ marginRight: 5 }} />
                                    Add Co-ordinator
                                </button>
                            }
                        </div>
                    </div>
                    <div className="coordinatorList" ref={el => this.printReference = el}>
                        <div className="college-info">
                            <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                            <h5 className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</h5>
                        </div>
                        <table className="table table-bordered table-responsive-sm" id="coordinatorList" style={{ background: '#FFF' }}>
                            <thead>
                                <tr>
                                    <th style={{ padding: 5 }}>Sr. No.</th>
                                    <th style={{ padding: 5 }}>Module Name</th>
                                    <th style={{ padding: 5 }}>Co-ordinator Name</th>
                                    <th style={{ padding: 5 }}>Role</th>
                                    <th style={{ padding: 5 }}>Designation</th>
                                    <th style={{ padding: 5 }}>Access Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.coordinatorFetching ?
                                        <tr>
                                            <td colSpan="6" style={{ padding: 5 }}>
                                                <ButtonLoader />
                                            </td>
                                        </tr>
                                    :
                                        Object.keys(this.state.coordinatorList).length > 0 ?
                                            Object.values(this.state.coordinatorList).map((module, moduleIndex) => {
                                                return(
                                                    <>
                                                        <tr key={module.moduleId}>
                                                            <td style={{ padding: 5 }} rowSpan={(module.coordinatorObj != undefined && Object.keys(module.coordinatorObj).length > 1) ? Object.keys(module.coordinatorObj).length : 1}>
                                                                {this.state.offset + moduleIndex + 1}.
                                                            </td>
                                                            <td style={{ padding: 5 }} rowSpan={(module.coordinatorObj != undefined && Object.keys(module.coordinatorObj).length > 1) ? Object.keys(module.coordinatorObj).length : 1}>
                                                                {module.moduleName}
                                                            </td>
                                                            {
                                                                module.coordinatorObj != undefined &&
                                                                    Object.keys(module.coordinatorObj).length > 0 ?
                                                                        Object.values(module.coordinatorObj).map((coordinator, coordinatorIndex) => {
                                                                            if(coordinatorIndex == 0) {
                                                                                return(
                                                                                    <>
                                                                                        <td style={{ padding: 5, borderLeft: Object.keys(module.coordinatorObj).length > 1 && '1px solid #dee2e6' }}>
                                                                                            <span>{coordinator.employeeName} |</span>
                                                                                            <span style={{marginLeft:5,color:coordinator.employeeStatus == "active" ? " #219653" :" #eb5757"}}>{coordinator.employeeStatus}</span>
                                                                                            {
                                                                                                Object.keys(coordinator.sidArray).length > 0 ?
                                                                                                    Object.values(coordinator.sidArray).map(stream => {
                                                                                                        return(
                                                                                                            <div className="coordinator-stream">
                                                                                                                {stream.streamName}
                                                                                                                {
                                                                                                                    this.state.onboardingAccess && 
                                                                                                                    <FontAwesomeIcon className="removeCoordinator" icon={['fas', 'times']} color="red" title="Click to remove coordinator" style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeCoordinator(module.moduleId, stream)} />
                                                                                                                }
                                                                                                            </div>
                                                                                                        );
                                                                                                    })
                                                                                                :
                                                                                                    <>
                                                                                                        {
                                                                                                            this.state.onboardingAccess && 
                                                                                                            <FontAwesomeIcon className="removeCoordinator" icon={['fas', 'times']} color="red" title="Click to remove coordinator" style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeCoordinator(module.moduleId, coordinator)} />
                                                                                                        }
                                                                                                    </>
                                                                                            }
                                                                                        </td>
                                                                                        <td style={{ textTransform: 'capitalize', padding: 5 }}>{coordinator.employeeRole}</td>
                                                                                        <td style={{ padding: 5 }}>{coordinator.employeeDesignation}</td>
                                                                                        <td style={{ textTransform: 'capitalize', color: coordinator.employeeStatus == 'active' ? '#219653' : '#EB5757', padding: 5 }}>{coordinator.employeeStatus}</td>
                                                                                    </>
                                                                                );
                                                                            }
                                                                        }) 
                                                                    :
                                                                        <>
                                                                            <td style={{ padding: 5 }}></td>
                                                                            <td style={{ padding: 5 }}></td>
                                                                            <td style={{ padding: 5 }}></td>
                                                                            <td style={{ padding: 5 }}></td>
                                                                            <td style={{ padding: 5 }}></td>
                                                                            <td style={{ padding: 5 }}></td>
                                                                        </>            
                                                            }
                                                        </tr>
                                                        {
                                                            (module.coordinatorObj != undefined && Object.keys(module.coordinatorObj).length > 0) &&
                                                                Object.values(module.coordinatorObj).map((coordinator, coordinatorIndex) => {
                                                                    if(coordinatorIndex > 0) {
                                                                        return(
                                                                            <tr>
                                                                                <td style={{ padding: 5, borderLeft: Object.keys(module.coordinatorObj).length > 1 && '1px solid #dee2e6' }}>
                                                                                    <span>{coordinator.employeeName} |</span>
                                                                                    <span style={{marginLeft:5,color:coordinator.employeeStatus == "active" ? " #219653" :" #eb5757"}}>{coordinator.employeeStatus}</span>
                                                                                    {
                                                                                        Object.keys(coordinator.sidArray).length > 0 ?
                                                                                            Object.values(coordinator.sidArray).map(stream => {
                                                                                                return(
                                                                                                    <div className="coordinator-stream">
                                                                                                        {stream.streamName}
                                                                                                        
                                                                                                        {
                                                                                                            this.state.onboardingAccess && 
                                                                                                            <FontAwesomeIcon className="removeCoordinator" icon={['fas', 'times']} color="red" title="Click to remove coordinator" style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeCoordinator(module.moduleId, stream)} />
                                                                                                        }
                                                                                                    </div>
                                                                                                );
                                                                                            })
                                                                                        :
                                                                                        <>
                                                                                            {
                                                                                                this.state.onboardingAccess && 
                                                                                                <FontAwesomeIcon className="removeCoordinator" icon={['fas', 'times']} color="red" title="Click to remove coordinator" style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeCoordinator(module.moduleId, coordinator)} />
                                                                                            }
                                                                                        </>
                                                                                    }
                                                                                </td>
                                                                                <td style={{ textTransform: 'capitalize', padding: 5 }}>{coordinator.employeeRole}</td>
                                                                                <td style={{ padding: 5 }}>{coordinator.employeeDesignation}</td>
                                                                                <td style={{ textTransform: 'capitalize', color: coordinator.employeeStatus == 'active' ? '#219653' : '#EB5757', padding: 5 }}>{coordinator.employeeStatus}</td>
                                                                            </tr>
                                                                        );
                                                                    }
                                                                }) 
                                                        }
                                                    </>
                                                );
                                            })
                                        :
                                            <tr>
                                                <td colSpan="8" style={{ padding: 5 }}>No coordinator details found.</td>
                                            </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    {
                        Object.keys(this.state.coordinatorList).length > 0 &&
                            <div id="paginationContainer">
                                <Pagination
                                    activePage={this.state.pageIndex}
                                    itemsCountPerPage={this.state.limit}
                                    totalItemsCount={this.state.coordinatorCount}
                                    pageRangeDisplayed={3}
                                    onChange={(num) => this.updatePaginationCount(num)}
                                />
                            </div>
                    }
                </div>
                {
                    this.returnAddCoordinator()
                }
                {
                    this.returnSelectModule()
                }
                {
                    this.returnSelectEmployee()
                }
                {
                    this.returnDemoPointAttachment()
                }
                {
                    this.returnViewDetailedPresentation()
                }
                {
                    // this.returnPresentationData()
                }
                {
                    this.returnProductHelp()
                }
                {
                    this.state.deleteCoordinator &&
                        <DeleteTextModal
                            showModal={this.state.deleteCoordinator}
                            visibility={this.closeDeleteCoordinator}
                            deleteKey='Coordinator'
                            deleteComponent={this.apiCallToDeleteCoordinator}
                        />
                }
                {
                    this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal} 
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal} 
                        />
                }
                <br/>
            </>
        );
    }
}

export default CoordinatorDetails;